import { TAppMaster } from '@monorepo/resolvers';
import { TRESPONSE_SHIFTS, SessionTimes } from '@monorepo/types';
import { Action } from '@ngrx/store';

// Actions
export enum ShiftsActionTypes {
  LoadShifts = '[SHIFT_DB] Load Shifts',
  FailedShiftsLoad = '[SHIFT_DB][FAILED] Fetching Shifts from Cache',
  ShiftsLoaded = '[SHIFT_DB] Shifts Loaded from Cache',
  SelectShift = '[SHIFT_DB] Slect Current Shift',
  SelectShiftFailed = '[SHIFT_DB] Problem Loading Slected Shift from store',
  ChangeShiftId = '[SHIFT_DB] change shift Id',
  FetchSessionPlans = '[Shifts] Fetch Session Plans',
  InitialiseAndFetchSessionPlans = '[Shifts] Initialise And Fetch Session Plans',
  CheckSessionHoursStatus = '[Shifts] Check Session Hours Status',
  UpdateSessionHoursStatus = '[Shifts] Update Session Hours Status',
  SessionPlansNoAction = '[Shifts] No Action',
}

export class LoadShifts implements Action {
  readonly type = ShiftsActionTypes.LoadShifts;
  constructor() {}
}

export class LoadShiftsFailed implements Action {
  readonly type = ShiftsActionTypes.FailedShiftsLoad;
  constructor() {}
}

export class ShiftsLoaded implements Action {
  readonly type = ShiftsActionTypes.ShiftsLoaded;
  constructor(public payload: TRESPONSE_SHIFTS) {}
}

export class SelectShift implements Action {
  readonly type = ShiftsActionTypes.SelectShift;
  constructor(public payload: string) {}
}
export class SelectShiftFailed implements Action {
  readonly type = ShiftsActionTypes.SelectShiftFailed;
  constructor() {}
}

export class ChangeShiftId implements Action {
  readonly type = ShiftsActionTypes.ChangeShiftId;
  constructor(public shiftId: string) {}
}

export class FetchSessionPlans implements Action {
  readonly type = ShiftsActionTypes.FetchSessionPlans;
  constructor(public fetchAllSubjects: boolean) {}
}

export class SessionPlansNoAction implements Action {
  readonly type = ShiftsActionTypes.SessionPlansNoAction;
  constructor() {}
}

export class InitialiseAndFetchSessionPlans implements Action {
  readonly type = ShiftsActionTypes.InitialiseAndFetchSessionPlans;
  constructor() {}
}

export class CheckSessionHoursStatus implements Action {
  readonly type = ShiftsActionTypes.CheckSessionHoursStatus;
  constructor() {}
}

export class UpdateSessionHoursStatus implements Action {
  readonly type = ShiftsActionTypes.UpdateSessionHoursStatus;
  constructor(public isWithinWorkingHours: boolean, public sessionTimes: SessionTimes) {}
}

export type TShiftsActions =
  | LoadShifts
  | LoadShiftsFailed
  | ShiftsLoaded
  | SelectShift
  | SelectShiftFailed
  | ChangeShiftId
  | FetchSessionPlans
  | InitialiseAndFetchSessionPlans
  | SessionPlansNoAction
  | CheckSessionHoursStatus
  | UpdateSessionHoursStatus;
